import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Box, Button, Form, TextInput, Select, Card, FormField, RadioButton, Text, RadioButtonGroup, TextArea } from "grommet";
import './MedicalEmergencyCreate.css';
import Symptoms from "./common/Symptoms";
import { FlightService } from "../../../../../../services/flights/flight.service";
import MedicalEmergencyService from "../../../../../../services/medical-emergency/medical-emergency.service";
import PassengerService from "../../../../../../services/passenger/passenger.service";
import { NotificationHelper } from "../../../../../../util/notification/NotificationHelper";
import { MedicalEmergencyHelper } from "../../../../../../util/medical-emergency/MedicalEmergencyHelper";
import { useUser } from "../../../../context/User/UserContext";
import { EndpointService } from "../../../../../../services/endpoint/endpoint.service";
import { useNavigate } from "react-router-dom";
import { useStore } from "../../../../../../Hooks/useStore";
import { observer } from 'mobx-react';
import { MedicalEmergencyStatus } from "../../../../../../services/medical-emergency/typings/IMedicalEmergencyApiResponse";
import { Mixpanel } from "../../../../../../util/Helper";
import { Close } from "grommet-icons";
import usersService from "../../IAM/Users/users.service";
import PassengerDetail from "./PassengerDetail";
import { subscribeToTopic ,unsubscribeToTopic,sendDataToTopic} from "../../../../../../App";
import { Autoupdateenum } from "../../../../../../enums";

const MedicalEmergencyCreate = observer(() => {
    const { rootStore } = useStore();

    const { setUser, user } = useUser();
    const navigate = useNavigate();
    

    useEffect(() => {
        return () => {
            console.log("reset selcted ME on component unmopunt");
            rootStore.emsStore.handleSelectedEmergency(null);
            rootStore.emsStore.passenger = null;
            rootStore.emsStore.handleVideoCallRecord(null);
            rootStore.emsStore.resetSymptom();
            rootStore.emsStore.handleOtherSymptoms("");
            rootStore.emsStore.handleOtherSympInput(false);
            rootStore.emsStore.resetReportIndicator();
        }
    }, []);

    useEffect(() => {
        rootStore.emsStore.flightList = [];
        rootStore.emsStore.crewList = [];
        rootStore.emsStore.handleOrgList([]);
        rootStore.emsStore.handleSelectedOrgId("");
    },[]);

    // get flight related to selected organization
    const getFlightrelatedToOrg = async (orgId) => {
        rootStore.emsStore.flightList = [];
        rootStore.emsStore.crewList = [];
        rootStore.emsStore.handleSelectedFlight("");
        rootStore.emsStore.handleSelectedCrew("");
        let Flights = await FlightService.getFlightRelatedToOrgId(orgId);
        console.log("Flight List", Flights);
        rootStore.emsStore.flightList = Flights;
        rootStore.emsStore.flightStoreList = Flights;
    }

    // get crew related to selected flight
    const getCrewrelatedToFlight = async (flightId) => {
        rootStore.emsStore.handleSelectedCrew("");
        let Crews = await FlightService.getCrewRelatedToFlight(flightId);
        console.log("Crew List", Crews);
        rootStore.emsStore.crewList = Crews;
    }

    const onBackHandlerPress = () => {
        Mixpanel.track("web_initiate_medical_emergency_back_click",{name: user?.username});
        rootStore.emsStore.handleShowDetails({
            showSymptoms: false,
            filterEnable: false
        });
    }

    const resetState = () => {
        rootStore.emsStore.handlePassengerName('');
        rootStore.emsStore.handleSelectedFlight('');
        rootStore.emsStore.handleSelectedGender("");
        rootStore.emsStore.handleSelectedAge('');
        rootStore.emsStore.handleSelectedCrew("");
        rootStore.emsStore.handleSelectedOrgId("");
        rootStore.emsStore.flightList = [];
    }


    const notifyUsers = useCallback(
        async (sentBy, messageContent, id) => {
            console.log("sentBy, messageContent, id", sentBy, messageContent, id);
            const notificationHelper = new NotificationHelper();
            const medicalEmergencyHelper = new MedicalEmergencyHelper();

            console.log("notificationHelper", notificationHelper);
            console.log("medicalEmergencyHelper", medicalEmergencyHelper);
            let users = [];
            let usernames = [];
            let cognitoCrewUserId = null;
            let emsName = null;

            cognitoCrewUserId = await medicalEmergencyHelper.findCrew(id);
            console.log("cognitoCrewUserId", cognitoCrewUserId);
            emsName = await medicalEmergencyHelper.findEmsName(id);
            console.log("emsName", emsName);

            if (cognitoCrewUserId) {
                console.log("cognitoCrewUserId inside if block", cognitoCrewUserId);
                users.push(cognitoCrewUserId);
            }

            if (emsName) {
                console.log("emsName inside if block", emsName);
                usernames.push(emsName);
            }

            if (users.length != 0) {
                console.log("send notification to app");
                try {
                    notificationHelper.sendNotification(sentBy, messageContent, users);
                } catch (error) {
                    console.log("Error in send app notification.", error);
                    return true;
                }
            }

            if (usernames.length != 0) {
                console.log("send notification to web");
                try {
                    await EndpointService.notifyWebUser(sentBy, messageContent, usernames);
                } catch (error) {
                    console.log("Error in send web notification.", error);
                    return true;
                }
            }
            rootStore.emsStore.handleShowDetails({
                showSymptoms: false,
                filterEnable: false
            });
            return true;
        },
        [user]
    );

    const nextHandler = () => {
        if (!rootStore.emsStore.getSelectedOrgId) {
            alert("Please Select Organization");
            return;
        } else if (!rootStore.emsStore.getSelectedFlight) {
            alert("Please Select Flight.");
            return;
        } else if (!rootStore.emsStore.getSelectedCrew) {
            alert("Please Select Crew.");
            return;
        } else {
            rootStore.emsStore.handleShowDetails({
                showSymptoms: true,
                filterEnable: false
            });
            Mixpanel.track("web_initiate_medical_emergency_next_click",{
                passengerName: rootStore.emsStore.getPassengerName,
                age: rootStore.emsStore.getSelectedAge,
                gender: rootStore.emsStore.getSelectedGender || "Other",
                name: user?.username
            });
        }
    }
    useEffect(() => {
        resetState();
    }, []);

    const onNextClick = () => {
        rootStore.emsStore.handlePassengerDetail(true);
        // Mixpanel.track("web_initiate_medical_emergency_next_click", {
        //     passengerName: rootStore.emsStore.getPassengerName,
        //     age: rootStore.emsStore.getSelectedAge,
        //     gender: rootStore.emsStore.getSelectedGender || "Other"
        // });
    }

    const onDoneHandlerPress = async (symptoms, crewNotes) => {
       if(rootStore.emsStore.getPassengerName && rootStore.emsStore.getPassengerName.trim()!==""){
        Mixpanel.track("web_initiate_medical_emergency_done_click",{name:user?.username});
        rootStore.loadingStore.setShowLoader(true);
        const passenger = {
            org: rootStore.emsStore.getSelectedOrgId,
            name: rootStore.emsStore.getPassengerName,
            age: rootStore.emsStore.getSelectedAge,
            gender: rootStore.emsStore.getSelectedGender
        }

        const medicalEmergency = {
            symptoms: symptoms,
            passengerStatusQuestions: [],
            createdBy: user.username,
            assignedCrew: rootStore.emsStore.getSelectedCrew,
            flightId: rootStore.emsStore.getSelectedFlight,
            status: 'NOTIFIED',
            treatmentsGiven: [],
            crewNotes: crewNotes
        };


        let res = await PassengerService.createPassengerAndEmergency(passenger, medicalEmergency, rootStore.emsStore.getSelectedPassengerId, rootStore.emsStore.getPassengerConscious || false);
        console.log("created medical", res);
        if (res !== undefined) {
            let notificationResponse = await notifyUsers("Medical Event Reported", "Action Required", res.id);
            console.log("notificationResponse", notificationResponse);
            if (notificationResponse) {
                resetState();
                if (res?.assignedEms === user?.username) {
                    MedicalEmergencyService.setMedicalEmergencyStatus(
                        res.id,
                        MedicalEmergencyStatus.MONITORING
                    );
                }
               // alert(rootStore.emsStore.getSelectedFlight);
                sendDataToTopic(res.id,res.flightId,Autoupdateenum.List);
               navigate(`/ems/medical-emergencies/emergency/${res.id}`);
                rootStore.emsStore.handleShowDetails({
                    showSymptoms: false,
                    filterEnable: false
                });

              

            }
        }
        rootStore.loadingStore.setShowLoader(false);
        rootStore.emsStore.handlePassengerDetail(false);
       }else{
        rootStore.emsStore.handlePassengerNameError(true)
       }
    }

    const [filteredCrewList, setFilteredCrewList] = useState([]);

    // Memoize the crew list to avoid unnecessary re-renders
    const crewList = useMemo(() => rootStore.emsStore.getCrewList, [rootStore.emsStore.getCrewList]);
    
    useEffect(() => {
        setFilteredCrewList(crewList); // Initialize the filtered list with the full crew list
    }, [crewList]); // Only update when crewList changes

    const filterCrew = useCallback(
        (searchString) => {
            let crewListUpdation = rootStore.emsStore.getCrewList;
            if (searchString) {
                let newCrewList = crewListUpdation.filter(a => {
                    return a.toLowerCase().includes(searchString.toLowerCase());
                });
                // rootStore.emsStore.crewList = newCrewList;
                setFilteredCrewList(newCrewList)
            } else {
                // rootStore.emsStore.crewList = rootStore.emsStore.crewStoreList;
                setFilteredCrewList(crewList)
            }
        },[crewList]
    ) 

    useEffect(() => {
        (async () => {
          rootStore.loadingStore.setShowLoader(true);
          const organizationsResponse = await usersService.listOrganizations();
          rootStore.emsStore.handleOrgList(organizationsResponse);
          rootStore.loadingStore.setShowLoader(false);
        })().catch((e) => rootStore.loadingStore.setShowLoader(false));
      }, []);

     const crew = [{value: 1, name: "jaycrew"},{value: 2, name: "mustafa.poc.crew"}]

        const [filteredFlightList, setFilteredFlightList] = useState([]);
        const flightList = useMemo(() => rootStore.emsStore.getFlightList, [rootStore.emsStore.getFlightList]);

        useEffect(() => {
            setFilteredFlightList(flightList);
        }, [flightList]);
    const filterFlight = (searchString) => {
        let flightListUpdation = rootStore.emsStore.getFlightList;
        if (searchString) {
            let newFlightList = flightListUpdation.filter(a => {
                return a.tailNumber.toLowerCase().includes(searchString.toLowerCase());
            });
            // rootStore.emsStore.flightList = newFlightList;
            setFilteredFlightList(newFlightList)
        } else {
            // rootStore.emsStore.flightList = rootStore.emsStore.getFlightStoreList;
            setFilteredFlightList(rootStore.emsStore.getFlightStoreList)
        }
    }

    const [filteredOrgList, setFilteredOrgList] = useState([]);

// Memoize the organization list to avoid unnecessary re-renders
const orgList = useMemo(() => rootStore.emsStore.getOrgStoreList, [rootStore.emsStore.getOrgStoreList]);

useEffect(() => {
    setFilteredOrgList(orgList); // Initialize the filtered list with the full organization list
}, [orgList]); // Only update when orgList changes

// Debounce the filter function to improve performance
const filterOrg = useCallback(
    (searchString) => {
        if (searchString) {
            const newFlightList = orgList.filter(org =>
                org.name.toLowerCase().includes(searchString.toLowerCase())
            );
            setFilteredOrgList(newFlightList);
        } else {
            setFilteredOrgList(orgList);
        }
    },
    [orgList] // Dependency on orgList to avoid infinite re-renders
);

    useEffect(() => {
        (async () => {
            rootStore.loadingStore.setShowLoader(true);
            const organizationsResponse = await usersService.listOrganizations();
            rootStore.emsStore.handleOrgList(organizationsResponse);
            rootStore.emsStore.handleOrgStoreList(organizationsResponse);
            rootStore.loadingStore.setShowLoader(false);
        })().catch((e) => rootStore.loadingStore.setShowLoader(false));
    }, []);

    return (
        <>
            {rootStore.emsStore.passengerDetail === false ?
        <div className="create-medical-container">
                <Card style={{ position: 'relative', height: "100%"}}>
                    <h1 className="page-headeing">Initiate Medical Event</h1>
                    <Form validate="change">
                        <div className="input_row org_row">
                            <div className="org_row_items input_row_item_crew">
                                <div className="input_title">Organization</div>
                                <Select
                                    name="organization"
                                    placeholder={"Please Select Organization"}
                                    options={filteredOrgList.map((org) => ({
                                        label: org.name,
                                        value: org.id,
                                      }))}
                                    labelKey={"label"}
                                    valueKey={{ key: "value", reduce: true }}
                                    value={rootStore.emsStore.getSelectedOrgId}
                                    defaultValue={""}
                                    onChange={(event) => {
                                        rootStore.emsStore.handleSelectedOrgId(event.option.value);
                                        getFlightrelatedToOrg(event.option.value);
                                        setFilteredOrgList(rootStore.emsStore.getOrgStoreList);
                                    }}
                                    onSearch={(value) => filterOrg(value)}
                                    onBlur={() => filterOrg("")}
                                    required
                                    className="select-org1234"
                                />
                                <span className='error_text_hide'>
                                    {!rootStore.emsStore.getSelectedCrew ? '**Please select crew**' : ' '}
                                </span>
                            </div>
                        </div>
                        <div className="input_row">
                        <div className="input_row_items input_row_items_flight">
                                <div className="input_title">Flight</div>
                                <Select
                                    name="flight"
                                    labelKey={"label"}
                                    valueKey={{ key: "value", reduce: true }}
                                    // options={rootStore.emsStore.getFlightList.map((org) => {
                                    //     return {
                                    //         label: org.tailNumber,
                                    //         value: org.id,
                                    //     };
                                    // })}
                                    options={filteredFlightList.map((org) => {
                                        return {
                                            label: org.tailNumber,
                                            value: org.id,
                                        };
                                    })}
                                    placeholder={"Please Select Flight"}
                                    value={rootStore.emsStore.getSelectedFlight}
                                    defaultValue={""}
                                    required
                                    onSearch={(value) => filterFlight(value)}
                                    onBlur={() => filterFlight("")}
                                    onChange={(event) => { rootStore.emsStore.handleSelectedFlight(event.option.value); getCrewrelatedToFlight(event.option.value); setFilteredFlightList(rootStore.emsStore.getFlightList) }}
                                    className="select"
                                    style={{height:"30px"}}
                                />
                                <span className='error_text_hide'>
                                    {!rootStore.emsStore.getSelectedFlight ? '**Please select Flight**' : ''}
                                </span>
                            </div>
                        <div className="input_row_items input_row_item_crew">
                                <div className="input_title">Crew</div>
                                <Select
                                    // options={rootStore.emsStore.getCrewList}
                                    options={filteredCrewList}
                                    placeholder={"Please Select Crew"}
                                    multiple={false}
                                    value={rootStore.emsStore.getSelectedCrew}
                                    required
                                    onChange={({ option }) => { 
                                        rootStore.emsStore.handleSelectedCrew(option);
                                        setFilteredCrewList(rootStore.emsStore.getCrewList)
                                    }}
                                    onSearch={(value) => filterCrew(value)}
                                    onBlur={() => filterCrew("")}
                                    searchPlaceholder="search..."
                                    className="select"
                                    style={{height:"30px"}}
                                />
                                <span className='error_text_hide'>
                                    {!rootStore.emsStore.getSelectedCrew ? '**Please select crew**' : ' '}
                                </span>
                            </div>
                        </div>
                        <div className="next-btn-outer">
                            <button 
                            style={{ cursor:"pointer", backgroundColor: (!rootStore.emsStore.getSelectedCrew || !rootStore.emsStore.getSelectedFlight || !rootStore.emsStore.getSelectedOrgId) ? "#C0C5CF" : "#357EFF", border: (!rootStore.emsStore.getSelectedCrew || !rootStore.emsStore.getSelectedFlight || !rootStore.emsStore.getSelectedOrgId) ? "1px solid #C0C5CF" : "1px solid #357EFF" }} 
                            disabled={(!rootStore.emsStore.getSelectedCrew || !rootStore.emsStore.getSelectedFlight || !rootStore.emsStore.getSelectedOrgId) ? true : false} 
                            onClick={onNextClick} className="nextBtn">Next</button>
                        </div>
                </Form>
            </Card>
            </div >
            :
            <PassengerDetail onDone={onDoneHandlerPress} />
        }
        </>
    );
});

export default MedicalEmergencyCreate;